// =============================================================================
//  Copyright : 2021 semantics GmbH
//  Date      : $Date: 2024-12-18 15:02:00 +0100 (Wed, 18 Dec 2024) $
//  Author    : Dirk Rothe
//  Worker    : $Author: d.rothe $
//  Revision  : $Rev: 148605 $
//  Purpose   : hocr rendering support
// =============================================================================
// ---Third-party imports
import React from 'react'

// ---Framework imports
import log from 'uix/logging'
import {AutoPortal} from 'uix/components/portals'

// ---Exports
import {SOFT_HYPHEN} from './constants'

export const hocrLine = {
  //~ tagMatcher: 'span',
  match: ({tag, attrib}) => tag == 'span' && attrib.className == 'ocr_line',
  build: ({applyTemplates, children}) => {
    let last_word = children.slice(-1)[0]
    let ws = last_word?.text?.endsWith(SOFT_HYPHEN) ? '' : ' '
    return (
      <span className="ocr_line">
        {applyTemplates(children)}
        {ws}
      </span>
    )
  },
}

export const hocrFootnote = {
  //~ tagMatcher: 'span',
  match: ({tag, attrib}) => tag == 'span' && attrib.className == 'footnote',
  build: ({applyTemplates, children, keys, attrib, ...rest}) => {
    let footnotes = keys.byClassName['footnote'].filter(({tag}) => tag == 'span')
    let index = footnotes.findIndex(e => attrib.id == e.attrib.id)
    // XXX: render annotation children
    return <sup>{index + 1 || 0}</sup>
  },
  init: ({keys, applyTemplates}) => {
    let footnotes = keys.byClassName['footnote']?.filter(({tag}) => tag == 'span') || []
    let items = footnotes.map(({attrib, children}, i) => {
      return <li key={i}>{applyTemplates(children)}</li>
    })
    return (
      <AutoPortal target="WikiFooterTarget">
        <div className="footnotes">
          <hr style={{borderBottom: '1px solid #666'}} />
          <ol>{items}</ol>
        </div>
      </AutoPortal>
    )
  },
}
